import React from 'react';
import SEO from '../components/SEO';

const Contact = () => {
  return (
    <div className="min-h-screen bg-gray-50 pt-20">
      <SEO
        title="Contact | E-omi Services"
        description="Contactez E-omi Services pour un devis gratuit. Téléphone: +33 6 60 88 64 51. Intervention en Île-de-France, 7j/7 de 7h à 20h."
        path="/contact"
      />
      {/* Hero Section */}
      <div className="bg-blue-600 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6">
            Contactez-nous
          </h1>
          <p className="text-lg sm:text-xl max-w-3xl mx-auto text-blue-100">
            Notre équipe est à votre écoute pour répondre à toutes vos questions
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Contact Info */}
        <div className="space-y-8">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 text-center">
            Informations de Contact
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
            <div className="contact-card p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
              <div className="flex items-start space-x-4">
                <div className="text-2xl">📱</div>
                <div className="flex-1">
                  <h3 className="font-semibold text-lg text-gray-800 mb-2">Téléphone</h3>
                  <p className="text-gray-600 mb-3">Pour toute demande, n'hésitez pas à nous appeler :</p>
                  <a href="tel:+33660886451" className="text-blue-600 hover:text-blue-700 font-medium text-lg">
                    +33 6 60 88 64 51
                  </a>
                </div>
              </div>
            </div>

            <div className="contact-card p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
              <div className="flex items-start space-x-4">
                <div className="text-2xl">📧</div>
                <div className="flex-1">
                  <h3 className="font-semibold text-lg text-gray-800 mb-2">Email</h3>
                  <p className="text-gray-600 mb-3">Pour toute question, vous pouvez nous écrire à :</p>
                  <a href="mailto:Contact@e-omiservices.fr" className="text-blue-600 hover:text-blue-700 font-medium break-all">
                    Contact@e-omiservices.fr
                  </a>
                </div>
              </div>
            </div>

            <div className="contact-card p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
              <div className="flex items-start space-x-4">
                <div className="text-2xl">📍</div>
                <div className="flex-1">
                  <h3 className="font-semibold text-lg text-gray-800 mb-2">Zone de Service</h3>
                  <p className="text-gray-600 mb-3">Nous intervenons dans toute la région :</p>
                  <a href="https://maps.google.com/?q=Île-de-France" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700 font-medium">
                    Île-de-France
                  </a>
                </div>
              </div>
            </div>

            <div className="contact-card p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
              <div className="flex items-start space-x-4">
                <div className="text-2xl">⏰</div>
                <div className="flex-1">
                  <h3 className="font-semibold text-lg text-gray-800 mb-2">Horaires</h3>
                  <p className="text-gray-600 mb-3">Disponibles 7 jours sur 7 :</p>
                  <p className="text-blue-600 font-medium">Lun-Dim: 7h-20h</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact; 